import React from 'react';
import { Box, Container, Grid, Typography, IconButton, Link } from '@mui/material';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GitHubIcon from '@mui/icons-material/GitHub';
import EmailIcon from '@mui/icons-material/Email';

const Footer: React.FC = () => (
  <Box
    component="footer"
    sx={{
      bgcolor: '#0c0c0c',
      borderTop: '1px solid rgba(255, 255, 255, 0.06)',
      py: 8,
    }}
  >
    <Container maxWidth="lg">
      <Grid container spacing={4}>
        <Grid size={{ xs: 12, md: 4 }}>
          <Typography
            variant="h6"
            sx={{
              fontFamily: '"Bricolage Grotesque", sans-serif',
              fontWeight: 800,
              color: '#ffffff',
              mb: 2,
              letterSpacing: '-0.02em',
            }}
          >
            ZerveMe
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 300 }}>
            Makers of ToStructure — a native desktop AI app for data analytics on Mac and Windows.
            Also offering expert consulting in data engineering, software, and AI/ML.
          </Typography>
        </Grid>

        <Grid size={{ xs: 6, md: 2 }}>
          <Typography variant="body2" sx={{ mb: 2, fontWeight: 600, color: '#ffffff' }}>
            Services
          </Typography>
          {['Data Engineering', 'Software Engineering', 'AI / ML', 'Cloud & Infra'].map(
            (item) => (
              <Typography
                key={item}
                variant="body2"
                color="text.secondary"
                sx={{ mb: 1 }}
              >
                {item}
              </Typography>
            )
          )}
        </Grid>

        <Grid size={{ xs: 6, md: 2 }}>
          <Typography variant="body2" sx={{ mb: 2, fontWeight: 600, color: '#ffffff' }}>
            ToStructure
          </Typography>
          {['Natural Language SQL', 'Multi-Database', 'AI Visualizations', 'Citations', 'Local AI Models'].map(
            (item) => (
              <Typography
                key={item}
                variant="body2"
                color="text.secondary"
                sx={{ mb: 1 }}
              >
                {item}
              </Typography>
            )
          )}
        </Grid>

        <Grid size={{ xs: 12, md: 4 }}>
          <Typography variant="body2" sx={{ mb: 2, fontWeight: 600, color: '#ffffff' }}>
            Connect
          </Typography>
          <Box sx={{ display: 'flex', gap: 1 }}>
            <IconButton
              component="a"
              href="https://www.linkedin.com/in/kevin-singh-908547b4"
              target="_blank"
              rel="noopener noreferrer"
              size="small"
              sx={{
                color: 'text.secondary',
                '&:hover': { color: '#ffffff' },
                transition: 'color 0.2s ease',
              }}
            >
              <LinkedInIcon fontSize="small" />
            </IconButton>
            <IconButton
              component="a"
              href="https://github.com/kevinsinghdeveloper"
              target="_blank"
              rel="noopener noreferrer"
              size="small"
              sx={{
                color: 'text.secondary',
                '&:hover': { color: '#ffffff' },
                transition: 'color 0.2s ease',
              }}
            >
              <GitHubIcon fontSize="small" />
            </IconButton>
            <IconButton
              component="a"
              href="mailto:kevin@zerveme.com"
              size="small"
              sx={{
                color: 'text.secondary',
                '&:hover': { color: '#ffffff' },
                transition: 'color 0.2s ease',
              }}
            >
              <EmailIcon fontSize="small" />
            </IconButton>
          </Box>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
            <Link
              href="mailto:kevin@zerveme.com"
              color="inherit"
              underline="hover"
            >
              kevin@zerveme.com
            </Link>
          </Typography>
        </Grid>
      </Grid>

      <Box
        sx={{
          mt: 8,
          pt: 4,
          borderTop: '1px solid rgba(255, 255, 255, 0.06)',
          textAlign: 'center',
        }}
      >
        <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.8rem' }}>
          &copy; {new Date().getFullYear()} ZerveMe LLC. All rights reserved.
        </Typography>
      </Box>
    </Container>
  </Box>
);

export default Footer;
